export default "__VITE_ASSET__9d89d81d__"